import React from 'react'
import AuthenticationForm from '../../features/login/AuthenticationForm'

const Authentication = () => {
    return (
        <AuthenticationForm />
    )
}

export default Authentication